import type { ValidatorStats } from "types/validator-info";

export enum PreselectionType {
  HighestSolValue,
  LargestStakeAccountMsolPrio,
  Unselected,
}

export enum EligibilityType {
  Never,
  Active,
  InOneEpoch,
  InTwoEpochs,
  Locked,
}

export enum StakeAccountType {
  Activating = "Activating",
  Initialized = "Initialized",
  Delegated = "Delegated",
  Deactivating = "Deactivating",
  Deactivated = "Deactivated",
  Locked = "Locked",
  Unknown = "Unknown",
}

export type StakeAccountInfo = {
  address: string;
  balance: number;
  balanceExact: string;
  eligibility: EligibilityType;
  stakeAccountType: StakeAccountType;
  voteAddress: string;
  stakingAuthority: string;
  validatorInfo?: ValidatorStats;
  lockup: {
    custodian: string;
    epoch: number;
    unixTimestamp: number;
  };
};
